import {ReactComponent as Icon} from '@image/icon_emergency.svg';

const IconEmergency = () => {
    return   <Icon />;
};

export default IconEmergency;